// import 'packages/monitor'
import { createApp } from 'vue'
import 'packages/style/index.scss'
import App from './App.vue'
import router from 'packages/router'
import { pinia } from 'packages/pinia'
import { ensureI18nLocale, i18n } from 'packages/i18n'
import { themePlugin } from 'packages/theme'
import { asyncRegister } from 'packages/dynamic'
import { bindNativeShell } from 'packages/utils/native'

// 壳里接管 Android 返回键。浏览器里这个函数立刻返回
bindNativeShell()
// App 一挂载就会 t()。语言包必须先到，不能放进 i18n 模块顶上 await
await ensureI18nLocale()
const app = createApp(App)
app.use(pinia)
app.use(i18n)
app.use(themePlugin)
app.use(router)
app.use(asyncRegister)
app.mount('#app')
